import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22.6667 22.6667L28 28M4 14.6667C4 20.5577 8.77563 25.3333 14.6667 25.3333C17.6173 25.3333 20.2881 24.1353 22.2192 22.1991C24.1436 20.2696 25.3333 17.6071 25.3333 14.6667C25.3333 8.77563 20.5577 4 14.6667 4C8.77563 4 4 8.77563 4 14.6667Z",
		stroke: "white",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSearch;
